/**
 * Action types for applying/removing cashpass reward certificates to/from the
 * cart (draft order) from the Rewards Center, and for fetching the list of
 * rewards currently applied to the cart.
 *
 * Approach B: the "applied rewards" GET API is the source of truth for which
 * cashpasses are applied and for the adjustment `id` required by DELETE. Apply
 * uses { code, serialNumber }; remove uses the adjustment `id`.
 */

// Fetch the rewards currently applied to the cart (GET).
export const GET_APPLIED_CASHPASS = 'GET_APPLIED_CASHPASS';
export const GET_APPLIED_CASHPASS_SUCCESS = 'GET_APPLIED_CASHPASS_SUCCESS';
export const GET_APPLIED_CASHPASS_ERROR = 'GET_APPLIED_CASHPASS_ERROR';

// Apply a cashpass to the cart (POST adjustment/discounts).
export const APPLY_CASHPASS = 'APPLY_CASHPASS';
export const APPLY_CASHPASS_SUCCESS = 'APPLY_CASHPASS_SUCCESS';
export const APPLY_CASHPASS_ERROR = 'APPLY_CASHPASS_ERROR';

// Remove a cashpass from the cart (DELETE adjustment/discounts/{id}).
export const REMOVE_CASHPASS = 'REMOVE_CASHPASS';
export const REMOVE_CASHPASS_SUCCESS = 'REMOVE_CASHPASS_SUCCESS';
export const REMOVE_CASHPASS_ERROR = 'REMOVE_CASHPASS_ERROR';

// Clear any captured apply/remove error (message) for a card.
export const CLEAR_CASHPASS_ERROR = 'CLEAR_CASHPASS_ERROR';

// Toggle the loader while an apply/remove/get call is in flight (saga-driven).
export const SET_CASHPASS_LOADING = 'SET_CASHPASS_LOADING';
